export default 'Your entry is too short.';